import Helper from '@ember/component/helper';
import type { SafeString } from '@ember/template';
import { htmlSafe } from '@ember/template';
import {
  JournalRow,
  JournalStageColumn,
} from 'donor-elf-web/lib/journal-utils';

interface NamedArgs {
  journalStageColumn: JournalStageColumn;
  journalRow: JournalRow;
}

export default Helper.extend({
  compute(
    _args: any,
    { journalStageColumn, journalRow }: NamedArgs,
  ): SafeString | void {
    if (journalRow.active) {
      return htmlSafe('bg-brand-50');
    }
    if (
      journalStageColumn.isStageColumn &&
      (journalStageColumn.stageIndex <=
        journalRow.journalContactInfo.lastCompletedStageIndex ||
        journalRow.journalContactInfo.journalContact.finished)
    ) {
      return htmlSafe('bg-gray-100');
    }
  },
});
